// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const FormValidation = t.struct({
    comments: t.Bool,
    machineType: t.Bool,
    pin: t.Bool,
    planName: t.Bool,
    referenceNumber1: t.Bool,
    responsibleAccount: t.Bool,
    serviceDate: t.Bool,
    serviceInterval: t.Bool,
    useAmount: t.Bool,
    useAmountUnit: t.Bool
}, 'FormValidation');

export const getDefaultState = () => new FormValidation({
    comments: true,
    machineType: true,
    pin: true,
    planName: true,
    referenceNumber1: true,
    responsibleAccount: true,
    serviceDate: true,
    serviceInterval: true,
    useAmount: true,
    useAmountUnit: true
});

export default FormValidation;



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/state/form-validation.js